module.exports = __webpack_public_path__ + "static/media/SKM.15e415fc.png";